export { resolvePositioningShorthand } from '@fluentui/react-positioning';
export { usePositioning } from './usePositioning';
export { getPlacementString } from './utils';
export { POSITIONS, ALIGNMENTS } from './constants';
export type { PositioningProps, PositioningReturn } from './types';
export type {
  Alignment,
  Position,
  PositioningImperativeRef,
  PositioningShorthand,
  PositioningShorthandValue,
} from '@fluentui/react-positioning';
